import React from 'react';

const RealTimeOscillator = ({ sentiment, isRecording = false }) => {
  if (!isRecording) return null;
  const getGradient = () => {
    if (sentiment > 50) return 'bg-gradient-to-r from-green-400 to-green-600';
    if (sentiment < 50) return 'bg-gradient-to-r from-red-400 to-red-600';
    return 'bg-gradient-to-r from-gray-400 to-gray-600';
  };

  const getText = () => {
    if (sentiment > 0) return 'Empathy Meter';
    if (sentiment < 0) return 'Empathy Meter';
    return 'Empathy Meter';
  };

  return (
    <div className="flex items-center justify-center -mt-24 sm:-mt-20 md:-mt-24 lg:-mt-32">
      <div
        className={`relative flex items-center justify-center w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full transition-all duration-500 shadow-lg ${getGradient()}`}
      >
        <div
          className="absolute w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-full bg-white opacity-30 animate-ping"
        ></div>
        <div
          className="absolute w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full bg-white opacity-20 animate-pulse"
        ></div>
        <span className="text-white font-bold text-base sm:text-lg md:text-xl z-10 flex items-center justify-center text-center w-full h-full">
          {getText()}
        </span>

      </div>
    </div>
  );
};

export default RealTimeOscillator;